import config from './_config'
import { Fixtures } from './types'
import { API } from '../../internal/types'
import { useInfiniteQuery } from '../../internal'

const useListEvents = (fixtureId, options?: API.QueryOptions) => {
  const query = useInfiniteQuery(undefined, options)

  const response = query<Fixtures.Event[]>({
    cacheKey: config.cacheKeys.events(fixtureId),
    endpoint: config.endpoints.events(fixtureId)
  })

  return response
}

export default useListEvents
